import React, { useEffect, useState, useRef } from "react";
import Banner from "./../banner/banner";
import * as api from "./../../api/api";
import MailIcon from "@material-ui/icons/Mail";
import SimpleReactValidator from "simple-react-validator";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

const initialFormData = {
  name: "",
  mobile_no: "",
  email_id: "",
  message: "",
};

export default function ContactUs() {
  const classes = useStyles();
  const [contact, setContact] = useState("");
  const [formData, setFormData] = useState(initialFormData);
  const [apiResponse, setApiResponse] = useState(null);
  const [loader, setLoader] = useState(true);
  const [banner, setBanner] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const simpleValidator = useRef(new SimpleReactValidator());
  useEffect(() => {
    document.title = "121five.com - Contact Us";
    window.scrollTo(0, 0);
    contactUsApi();
  }, []);

  const contactUsApi = async () => {
    try {
      let response = await api.contactUs();
      let res = await api.banner(4);

      if (response) {
        setContact(response);
        if (res) {
          setBanner(res.image);
          setLoader(false);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    setLoader(true);

    const { name, email_id, message, mobile_no } = formData;
    if (message) {
      setErrorMsg("");
    } else {
      setErrorMsg("Message Field Required");
      setLoader(false);
      return;
    }
    if (simpleValidator.current.allValid()) {
      try {
        const requestObj = {
          name: name,
          email_id: email_id,
          mobile_no: mobile_no,
          message: message,
        };
        const response = await api.contactUsData(requestObj);
        console.log(
          "This is response in contactUs TRY: " +
            JSON.stringify(response.status)
        );
        if (response.data) {
          setApiResponse(response.data.message);
          setLoader(false);
        }
      } catch (e) {
        setApiResponse("Internal Server Error");
        setLoader(false);
      }
    } else {
      simpleValidator.current.showMessages();
      setApiResponse("");
      setLoader(false);
    }
  };

  return (
    <div>
      <Banner img={banner} />
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-4">
              <div className="cv-contact-detail">
                <h2 className="cv-sidebar-title">Contact Info</h2>
                <p></p>
                {Object.keys(contact).map((index) => {
                  return (
                    <ul>
                      <li>
                        <div className="cv-contact-icon">
                          <MailIcon />
                        </div>
                        <div className="cv-contact-text">
                          <h3>{contact[index].title}</h3>
                          <p> {contact[index].description} </p>
                        </div>
                      </li>
                      <li></li>
                    </ul>
                  );
                })}
              </div>
            </div>

            <div className="col-lg-8 col-md-12">
              <div id="lightbox" className="lightbox py-5">
                <div className="container">
                  <div className="row mb-3">
                    <div className="col-md-10 mx-auto text-center">
                      <div className="headline">
                        <h2>Get a Quote</h2>
                        <p>Please take a look at some of them.</p>
                      </div>
                    </div>
                  </div>
                  <div className="lightbox_gallery">
                    <div className="row justify-content-lg-between justify-content-center">
                      <form
                        className="forms-sample col-lg-12"
                        encType="multipart/form-data"
                      >
                        <div className="row">
                          <div className="text-success p-3">{apiResponse}</div>

                          <div className="form-group col-lg-12">
                            <label for="exampleInputName1">
                              Name<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputName1"
                              placeholder="Name"
                              name="name"
                              onChange={onChange}
                              value={formData.name}
                            />
                            {simpleValidator.current.message(
                              "name",
                              formData.name,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>

                          <div className="form-group col-lg-12">
                            <label for="exampleInputEmail3">
                              Mobile Number
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Mobile Number"
                              name="mobile_no"
                              onChange={onChange}
                              value={formData.mobile_no}
                            />
                            {simpleValidator.current.message(
                              "Mobile Number",
                              formData.mobile_no,
                              "required|phone",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group col-lg-12">
                            <label for="exampleInputEmail3">
                              Email<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputEmail3"
                              placeholder="Email"
                              name="email_id"
                              onChange={onChange}
                              value={formData.email_id}
                            />
                            {simpleValidator.current.message(
                              "email_id",
                              formData.email_id,
                              "required|email",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group col-lg-12">
                            <label for="exampleInputEmail3">
                              Message<span className="text-danger">*</span>
                            </label>
                            <textarea
                              type="text-area"
                              className="form-control"
                              id="exampleInputEmail3"
                              placeholder="Message"
                              name="message"
                              onChange={onChange}
                              value={formData.message}
                            />
                          </div>
                          <p className="text-danger px-3">{errorMsg}</p>
                        </div>
                      </form>
                      <button
                        onClick={handleSubmit}
                        className="btn btn-gradient-primary ml-3"
                        style={{ color: "white" }}
                      >
                        Send
                      </button>

                      <Backdrop className={classes.backdrop} open={loader}>
                        <CircularProgress />
                      </Backdrop>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
